import { render, staticRenderFns } from "./notification-count.vue?vue&type=template&id=16112044&scoped=true"
import script from "./notification-count.vue?vue&type=script&lang=js"
export * from "./notification-count.vue?vue&type=script&lang=js"
import style0 from "./notification-count.vue?vue&type=style&index=0&id=16112044&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16112044",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16112044')) {
      api.createRecord('16112044', component.options)
    } else {
      api.reload('16112044', component.options)
    }
    module.hot.accept("./notification-count.vue?vue&type=template&id=16112044&scoped=true", function () {
      api.rerender('16112044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notifications/notification-count.vue"
export default component.exports